<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import store from '@/store'
import { triggers } from '@/scripts/global-modals-commands'
import SwordModal from '@/components/modals/SwordModal.vue'

const INCOMPLETE_PROFILE_MODAL_DATA = {
  headerStr: 'copy_4438',
  bodyStr: 'copy_4439',
  dismissButtonText: 'copy_4409',
  confirmButtonText: 'copy_4410',
}

const MISSING_PROFILE_MODAL_DATA = {
  headerStr: 'copy_3492',
  bodyStr: 'copy_3493',
  dismissButtonText: 'copy_3736',
  confirmButtonText: 'copy_3735',
}

const props = withDefaults(defineProps<{
  modalOpen?: boolean
  payload?: { modalContext?: string }
}>(), {
  modalOpen: false,
  payload: () => ({}),
})

const router = useRouter()

const stopShowing = ref(false)

const modalContext = computed(() => props.payload?.modalContext)
const isIncompleteProfileModal = computed(() => modalContext.value === 'incompleteProfile')
const metaData = computed(() =>
  !modalContext.value || !isIncompleteProfileModal.value ? MISSING_PROFILE_MODAL_DATA : INCOMPLETE_PROFILE_MODAL_DATA,
)

function dismissIncompleteOnboardingModal() {
  store.dispatch('user/preferences/setPreference', {
    key: 'dismissOnboardingProfileWarning',
    value: true,
    remote: true,
  })
}

function closeModal() {
  if (stopShowing.value) {
    dismissIncompleteOnboardingModal()
  }
  triggers.closeOnboardingProfileMissing()
}

function next() {
  if (stopShowing.value) {
    dismissIncompleteOnboardingModal()
  }
  router.push({ name: 'remote-config' })
  closeModal()
}
</script>

<template>
  <sword-modal v-if="!!modalContext" :header="metaData.headerStr" title="header" @close="closeModal">
    <template #body>
      <div class="w-[500px]">
        <p class="mb-0 text-t1">
          {{ $t(metaData.bodyStr) }}
        </p>
        <sword-checkbox
          v-model="stopShowing"
          :label="$t('copy_2475')"
          class="mt-8 text-start"
        />
      </div>
    </template>
    <template #footer>
      <div class="navigation">
        <div class="buttons-group">
          <sword-button-wuk theme="secondary" :text="metaData.dismissButtonText" @click.native="closeModal" />
          <sword-button-wuk :text="metaData.confirmButtonText" @click.native="next" />
        </div>
      </div>
    </template>
  </sword-modal>
</template>
